// console.log prefixed with the client-side time (HH:MM:SS.mmm). Used for FeedEngine
// lifecycle/state changes and network activity (polls, full feed fetches) so the lines
// can be correlated chronologically while debugging.
export function logWithTime(msg: string): void {
  const now = new Date();
  const time = `${now.toLocaleTimeString(undefined, { hour12: false })}.${String(now.getMilliseconds()).padStart(3, '0')}`;
  console.log(`[${time}] ${msg}`);
}
